<template>
  <div class="ma-2 insights-brows">
    <!-- heading starts -->
    <v-row>
      <v-col cols="7" md="5">
        <p class="text-h6 text--primary">Browse NHL Teams</p>
      </v-col>
      <v-spacer></v-spacer>
      <!-- <v-col cols="3" md="2" class="mr-4">
        <v-btn class="float-right btn-help-video" small color="#43A047">
          How to Use
        </v-btn>
      </v-col> -->
    </v-row>
    <!-- heading ends -->

    <!--//? search teams starts -->
    <v-row class="ma-2" justify="center">
      <div v-for="(data, index) in Teams.data" :key="index">
        <v-hover v-slot="{ hover }">
          <v-sheet
            height="75"
            width="75"
            color="#A7FFEB"
            :elevation="hover ? 6 : 1"
            class="d-flex align-center justify-center ma-1"
            rounded
            @click="scrollToTeam(data.TeamID)"
          >
            <v-img
              class="mx-auto"
              v-if="data.WikipediaLogoUrl"
              :src="data.WikipediaLogoUrl"
              max-height="55"
              max-width="55"
            />
          </v-sheet>
        </v-hover>
      </div>
    </v-row>
    <!-- <v-expansion-panels focusable>
      <v-expansion-panel>
        <v-expansion-panel-header class="text-sm-subtitle-2">
          Search By Team
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-multiselect-listbox
            :options="Teams.data"
            :reduce-display-property="
              (option) => `${option.Name} (${option.Key})`
            "
            :reduce-value-property="(option) => option.Key"
            selectedNoOptionsText=""
            v-model="selectedData"
          >
          </v-multiselect-listbox>
          <v-row>
            <v-col cols="3" md="4" sm="3" class="mt-3">
              <v-btn rounded color="primary" dark @click="getTeamId()">
                Search Teams
              </v-btn>
            </v-col>
          </v-row>


        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
    <!--//? search teams ends -->

    <!-- Team stats tab start -->
    <div v-for="n in 2" :key="n">
      <v-skeleton-loader
        v-if="getTeamLoader"
        :loading="getTeamLoader"
        transition="fade-transition"
        class="mb-3"
        type="table"
        elevation="2"
      >
      </v-skeleton-loader>
    </div>
    <!--//* the component tag will render dynamic component using the data function -->
    <component
      v-show="!getTeamLoader"
      v-bind:is="component"
      :Teams="this.cloneTeam"
      :operator="this.operator"
      :injuriesData="this.injuries"
      :depthChartData="this.depthChart"
      :upcomingGamesData="this.upcomingGames"
      :defaultSport="defaultSport"
      :defaultOptimizer="defaultOptimizer"
    ></component>
    <!-- Team stats tab end -->
  </div>
</template>

<script>
import _ from "lodash";
const statsTab = () => import("@/components/Tabs/statsTab.vue");
import { mapState, mapGetters } from "vuex";

export default {
  name: "NhlBrowseTeam",
  props: ["defaultSport", "defaultOptimizer"],

  components: {
    statsTab,
  },

  data() {
    return {
      component: "statsTab",
      selectedData: [],
      // page: 1,
    };
  },

  created() {
    this.fetchTeams();
  },

  computed: {
    ...mapState("NhlModule", [
      "Teams",
      "cloneTeam",
      "operator",
      "injuries",
      "depthChart",
      "upcomingGames",
    ]),
    ...mapGetters("NhlModule", ["loadingStatus", "getTeamLoader"]),
  },
  methods: {
    fetchTeams() {
      this.$store.dispatch("NhlModule/getTeams");
    },

    scrollToTeam(teamId) {
      let stud = document.querySelector(`#teamNo${teamId}`);
      let option = { duration: 1000 };
      this.$vuetify.goTo(stud, option);
    },

    getTeamId() {
      this.$store.state.NhlModule.cloneTeam = {
        ...this.$store.state.NhlModule.Teams,
      };
      this.$store.state.NhlModule.cloneTeam.data = _.intersection(
        this.cloneTeam.data,
        this.selectedData
      );
    },
  },
};
</script>

<style scoped></style>
